'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { PureComponent } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import text from 'I18n/utils/unescapedText';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { connect } from 'react-redux';
import CodeMirror from 'codemirror';
import 'codemirror/addon/runmode/runmode';
import 'codemirror/addon/runmode/colorize';
import { getThemeClassFromThemeName } from 'react-codemirror/util/Text';
import { getCodemirrorOptions } from 'DesignData/selectors/codemirror';
import UIButton from 'UIComponents/button/UIButton';
import UITable from 'UIComponents/table/UITable';
import UICopyButton from 'UIComponents/button/UICopyButton';

const i18nKey = key => `DesignEditorsUI.statusBar.header.reference.hublDocs.${key}`;

const mapStateToProps = state => {
  const {
    theme
  } = getCodemirrorOptions(state);
  return {
    codemirrorTheme: theme
  };
};

class HublDocsItem extends PureComponent {
  constructor(...args) {
    super(...args);
    this.state = {
      expanded: false
    };

    this.setSnippetRef = ref => {
      this.snippet = ref;
    };

    this.toggleCodeSnippet = () => {
      this.setState({
        expanded: !this.state.expanded
      });
    };
  }

  componentDidUpdate(prevState) {
    if (prevState.expanded !== this.state.expanded && this.snippet) {
      CodeMirror.colorize([this.snippet]);
    }
  }

  get codemirrorThemeClassName() {
    const {
      codemirrorTheme
    } = this.props;
    return getThemeClassFromThemeName(codemirrorTheme);
  }

  renderSnippet() {
    const {
      item
    } = this.props;
    const snippets = Object.keys(item.snippets);
    if (!snippets.length) return null;
    const codemirroClassName = classNames('hubl-code-container', this.codemirrorThemeClassName);
    return snippets.map((snippet, index) => {
      const codeSnippet = item.snippets[snippet].code;
      return /*#__PURE__*/_jsxs("div", {
        children: [/*#__PURE__*/_jsx("div", {
          className: codemirroClassName,
          children: /*#__PURE__*/_jsx("pre", {
            ref: this.setSnippetRef,
            "data-lang": "hubl-html",
            className: "hubl-code",
            children: item.snippets[snippet].code
          })
        }), /*#__PURE__*/_jsx(UICopyButton, {
          value: codeSnippet
        })]
      }, `snippet-${index}`);
    });
  }

  renderParams() {
    const {
      item
    } = this.props;
    if (!Object.keys(item.params).length) return null;
    return /*#__PURE__*/_jsxs(UITable, {
      className: "hubl-docs-item-params",
      children: [/*#__PURE__*/_jsxs("colgroup", {
        children: [/*#__PURE__*/_jsx("col", {
          width: "30%"
        }), /*#__PURE__*/_jsx("col", {
          width: "30%"
        }), /*#__PURE__*/_jsx("col", {
          width: "40%"
        })]
      }), /*#__PURE__*/_jsx("thead", {
        children: /*#__PURE__*/_jsxs("tr", {
          children: [/*#__PURE__*/_jsx("th", {
            children: text(i18nKey('params.name'))
          }), /*#__PURE__*/_jsx("th", {
            children: text(i18nKey('params.type'))
          }), /*#__PURE__*/_jsx("th", {
            children: text(i18nKey('params.desc'))
          })]
        })
      }), /*#__PURE__*/_jsx("tbody", {
        children: Object.keys(item.params).map((param, index) => {
          return /*#__PURE__*/_jsxs("tr", {
            children: [/*#__PURE__*/_jsx("td", {
              children: /*#__PURE__*/_jsx("code", {
                children: item.params[param].name
              })
            }), /*#__PURE__*/_jsx("td", {
              children: item.params[param].type
            }), /*#__PURE__*/_jsx("td", {
              children: item.params[param].desc
            })]
          }, `param-${index}`);
        })
      })]
    });
  }

  renderToggle() {
    const {
      params,
      snippets
    } = this.props.item;
    const {
      expanded
    } = this.state;
    const snippetKey = expanded ? 'snippetHide' : 'snippetOpen';

    if (!(Object.keys(params).length && Object.keys(snippets).length)) {
      return null;
    }

    return /*#__PURE__*/_jsx(UIButton, {
      use: "link",
      onClick: this.toggleCodeSnippet,
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: i18nKey(snippetKey)
      })
    });
  }

  renderCodeSnippet() {
    if (!this.state.expanded) return null;
    return /*#__PURE__*/_jsxs("div", {
      className: "hubl-docs-item-snippet",
      children: [this.renderSnippet(), this.renderParams()]
    });
  }

  render() {
    const {
      item
    } = this.props;
    return /*#__PURE__*/_jsxs("div", {
      className: "hubl-docs-item",
      children: [/*#__PURE__*/_jsx("h5", {
        className: "hubl-docs-item-title",
        children: item.name
      }), /*#__PURE__*/_jsx("div", {
        className: "hubl-docs-item-desc",
        children: item.desc
      }), this.renderCodeSnippet(), this.renderToggle()]
    }, item.name);
  }

}

HublDocsItem.propTypes = {
  item: PropTypes.object.isRequired,
  codemirrorTheme: PropTypes.string.isRequired
};
export default connect(mapStateToProps)(HublDocsItem);